export const GET_MEMBERINFO = 'getMemberInfo'
export const GET_COURSEINFO = 'getCourseInfo'
export const GET_SERVICE_AGREEMENT_STATUS = 'getServiceAgreementStatus'



// WEBPACK FOOTER //
// ./src/store/types.js